// extracted by mini-css-extract-plugin
module.exports = {"wrap":"avatar_wrap__391kX"};